module.exports = __webpack_public_path__ + "static/media/14.e0259a6c.jpg";